var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMobileView,
      expression: "!isMobileView"
    }],
    staticClass: "wheelSeg",
    style: Object.assign({
      position: 'absolute',
      height: _vm.matrix + 'px',
      width: _vm.matrix + 'px',
      transform: 'rotate(' + _vm.rotation + 'deg)',
      transformOrigin: 'center',
      zIndex: 100
    }, (_vm.positionTop || _vm.positionTop == 0) && {
      top: _vm.positionTop + 'px'
    }, (_vm.positionLeft || _vm.positionLeft == 0) && {
      left: _vm.positionLeft + 'px'
    }, (_vm.positionRight || _vm.positionRight == 0) && {
      right: _vm.positionRight + 'px'
    }, (_vm.positionBottom || _vm.positionBottom == 0) && {
      bottom: _vm.positionBottom + 'px'
    }),
    on: {
      "click": function () {
        _vm.clickHandler();
      },
      "mouseenter": function () {
        _vm.hoverActive = true;
      },
      "mouseleave": function () {
        _vm.hoverActive = false;
      }
    }
  }, [_vm.hoverActive || _vm.initialDefaultHoveredValues[_vm.wheelSegmentIndex] ? _c('div', {
    staticClass: "wheelSegGutsHover",
    style: {
      height: _vm.matrix + _vm.matrix * .20 + 'px',
      width: _vm.matrix + _vm.matrix * .20 + 'px'
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "alt": "image caption",
      "src": _vm.hoverImage
    }
  })]) : _vm._e(), !_vm.hoverActive ? _c('div', {
    staticClass: "wheelSegGuts"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "alt": "image caption",
      "src": _vm.defaultImage
    }
  })]) : _vm._e()])]);

}
var staticRenderFns = []

export { render, staticRenderFns }